import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CapitalizePipe } from './pipes/capitalize.pipe';
import { TrimPipe } from './pipes/trim.pipe';
import { SortByDirective } from './directives/sortby.directive';
import { MaterialModule } from './material.module';
import { I18NextModule } from 'angular-i18next';
import { ImagePipe } from './pipes/image.pipe';
import { ResourceNamePipe } from './pipes/quota-resource-name.pipe';
import { MomentTimezoneToAngularTimezonePipe } from './pipes/moment-timezone-to-angular-timezone.pipe';
import { DisableLinkIfNotAllowedDirective } from './directives/disable-link-if-not-allowed.directive';
import { HasPermissionDirective } from './directives/hasPermission.directive';
import { HideIfNotAllowedDirective } from './directives/hide-if-not-allowed.directive';
import { HideIfTenantConfigurationDisabledDirective } from './directives/hide-if-tenant-configuration-disabled.directive';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    I18NextModule,
    ResourceNamePipe,
    MomentTimezoneToAngularTimezonePipe,
    DisableLinkIfNotAllowedDirective,
    HideIfNotAllowedDirective,
  ],
  exports: [
    CommonModule,
    FormsModule,
    CapitalizePipe,
    ImagePipe,
    TrimPipe,
    ResourceNamePipe,
    MomentTimezoneToAngularTimezonePipe,
    SortByDirective,
    MaterialModule,
    I18NextModule,
    DisableLinkIfNotAllowedDirective,
    HasPermissionDirective,
    HideIfNotAllowedDirective,
    HideIfTenantConfigurationDisabledDirective,
  ],
  declarations: [
    CapitalizePipe,
    ImagePipe,
    TrimPipe,
    SortByDirective,
    HasPermissionDirective,
    HideIfTenantConfigurationDisabledDirective,
  ],
})
export class SharedModule {}
